import { z } from 'zod';
import { Admin, Role } from './admin.js';
/**
 * Server-side switches the SPA needs to decide what to SHOW (not what is
 * allowed — that is `permissions`). Each flag is `true` only when the feature
 * is actually served by this admin-api process.
 *
 * - `mcpDocs` — `/docs/mcp` is mounted (`MCP_DOCS_UPSTREAM_URL` +
 *   `MCP_DOCS_TOKEN` set AND the Scalar bundle loaded).
 */
export const MeFeatures = z.object({
    mcpDocs: z.boolean(),
});
export const MeResponse = z.object({
    admin: Admin,
    role: Role,
    permissions: z.array(z.string()),
    channelIds: z.array(z.guid()),
    timezone: z.string().min(1),
    // Optional on purpose (rollout invariant): a new admin-web bundle may talk
    // to an admin-api that does not send `features` yet; the SPA does not parse
    // `/api/me`, so every reader treats a missing flag as «off».
    features: MeFeatures.optional(),
});
//# sourceMappingURL=me.js.map